import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useMHRMedicinesModal = (customerID: string) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrMedicines($customerID: String) {
        mhrMedicines(customerId: $customerID) {
          html
          ok
          error
          documentId
          uniqueRepositoryId
        }
      }
    `),
    {
      variables: {
        customerID,
      },
    },
  );

  return {
    ok: data?.mhrMedicines?.ok ?? false,
    loading,
    error: error ? 'Error loading medicines view' : data?.mhrMedicines?.error,
    html: data?.mhrMedicines?.html,
    documentId: data?.mhrMedicines?.documentId,
    uniqueRepositoryId: data?.mhrMedicines?.uniqueRepositoryId,
  };
};
